/* PDP Enhancer (Shopify): progressive enhancement. The page works without JS. */
(function () {
  // "Write a review" / "Read all reviews" links jump to the theme's or review app's reviews block.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.pe a[href="#reviews"]');
    if (!a) return;
    var root = document.querySelector('.pe-shopify[data-reviews-anchor]');
    var sel = (root && root.getAttribute('data-reviews-anchor')) || '#judgeme_product_reviews, .jdgm-widget, #shopify-product-reviews, .spr-container, [id*="reviews"]';
    var t = document.querySelector(sel);
    if (t) { e.preventDefault(); t.scrollIntoView({behavior: 'smooth', block: 'start'}); }
  });
})();
/* PDP Enhancer: progressive enhancement. Content works without JS; this turns the fit/dosage
   tables into an interactive finder. */
function parseSize(raw) {
  var t = String(raw).trim().replace(',', '.').replace(/¼/, ' 1/4').replace(/½/, ' 1/2').replace(/¾/, ' 3/4');
  var m = t.match(/^(\d+(?:\.\d+)?)?\s*(?:(\d+)\s*\/\s*(\d+))?$/);
  if (!m || (!m[1] && !m[2])) return NaN;
  return (m[1] ? parseFloat(m[1]) : 0) + (m[2] ? parseInt(m[2], 10) / parseInt(m[3], 10) : 0);
}
function peInitFit(root) { root.querySelectorAll('.pe-fit[data-pe-fit]').forEach(function (el) {
  if (el.querySelector('.pe-fit__tool')) return;
  var cfg; try { cfg = JSON.parse(el.getAttribute('data-pe-fit')); } catch (e) { return; }
  var box = document.createElement('div'); box.className = 'pe-fit__tool';
  var id = 'pe-fit-' + Math.random().toString(36).slice(2, 7);
  box.innerHTML = '<label for="' + id + '">' + cfg.label + ' (' + cfg.unit + ')</label>' +
    '<div class="pe-fit__row"><input id="' + id + '" type="text" inputmode="decimal" autocomplete="off" placeholder="' + (cfg.placeholder || '') + '">' +
    '<output class="pe-fit__out" aria-live="polite"></output></div>';
  el.insertBefore(box, el.querySelector('.pe-table-wrap'));
  var input = box.querySelector('input'), out = box.querySelector('output');
  input.addEventListener('input', function () {
    var v = parseSize(input.value);  // accepts 5.1, 5,1, 5 1/4, 5¼
    el.querySelectorAll('tbody tr').forEach(function (tr) { tr.classList.remove('pe-hit'); });
    if (isNaN(v)) { out.textContent = ''; out.className = 'pe-fit__out'; return; }
    var floor = cfg.sizes[0].min || cfg.sizes[0].max * 0.75;  // soft floor: catches typos like 0.5
    if (v < floor) { out.textContent = cfg.small || 'Please re-measure.'; out.className = 'pe-fit__out pe-miss'; return; }
    var hit = -1;
    // smallest size whose upper bound fits the value (no gaps between rows)
    cfg.sizes.forEach(function (s, i) { if (v <= s.max && hit < 0) hit = i; });
    if (hit < 0) { out.textContent = cfg.none || 'No exact match. Contact us before ordering.'; out.className = 'pe-fit__out pe-miss'; return; }
    var s = cfg.sizes[hit]; out.className = 'pe-fit__out pe-ok';
    out.textContent = (cfg.result || 'Your size:') + ' ' + s.size + (s.note ? ' · ' + s.note : '');
    var tr = el.querySelectorAll('tbody tr')[hit]; if (tr) tr.classList.add('pe-hit');
  });
}); }
peInitFit(document);

/* Size finder next to the theme's size option: opens the page's fit finder / size guide in a dialog. */
(function () {
  var sec = document.querySelector('.pe-sec--fit_finder, .pe-sec--size_guide');
  if (!sec) return;
  var el = document.documentElement.lang.indexOf('el') === 0;
  var rx = /(μέγεθ|μεγεθ|νούμερ|νουμερ|size|taglia|größe)/i;
  var scope = document.querySelector('form[action*="/cart/add"]') ? document : null;
  if (!scope) return;
  var heads = Array.prototype.filter.call(
    document.querySelectorAll('form[action*="/cart/add"] legend, form[action*="/cart/add"] label, variant-selects legend, variant-selects label, variant-radios legend, .options-selection__option-name, .product-form__option-name, [data-option-name]'),
    function (n) { return rx.test(n.textContent) && !n.closest('.pe'); });
  if (!heads.length) return;
  var dlg = document.createElement('dialog');
  dlg.className = 'pe pe-dialog';
  dlg.setAttribute('aria-label', el ? 'Βρες το μέγεθός σου' : 'Find your size');
  var body = sec.cloneNode(true);
  body.removeAttribute('id');
  body.querySelectorAll('.pe-fit__tool').forEach(function (t) { t.remove(); });
  dlg.innerHTML = '<button type="button" class="pe-dialog__x" aria-label="' + (el ? 'Κλείσιμο' : 'Close') + '">×</button>';
  dlg.appendChild(body);
  document.body.appendChild(dlg);
  peInitFit(dlg);
  dlg.querySelector('.pe-dialog__x').addEventListener('click', function () { dlg.close(); });
  dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'pe-sizebtn';
  btn.innerHTML = '<span class="pe-sizebtn__i" aria-hidden="true"></span> ' + (el ? 'Βρες το μέγεθός σου' : 'Find your size');
  btn.addEventListener('click', function (e) {
    e.preventDefault();
    if (dlg.showModal) { dlg.showModal(); var i = dlg.querySelector('input'); if (i) i.focus(); }
    else sec.scrollIntoView({behavior: 'smooth'});
  });
  heads[0].insertAdjacentElement('afterend', btn);
})();
